<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";

   export default {
      page: {
         title: "Doctor Details",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Doctor Details",
            items: [
               {
                  text: "Doctors",
                  href: "/doctors",
               },                
               
               {
                  text: "Details",
                  active: true,
               },                     
            ],

            doctor: {},
            specializations: [],
            languages: [],
            certificates: [],
            bank_details: [],
            offline_count: '',
            online_count: '',
            new_pin: "",
            old_pin: "",
            errors: {},
            token: '',

            password: "",
            password_confirmation: "",

         };
      },
      mounted() {
    
      },

      created() {
         this.fetchDoctor();
      },

      methods: {

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchDoctor() {
            let url = "api/admin/doctors/details?doctor_id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.doctor = responseData.doctor;  
               this.specializations = responseData.specializations;
               this.languages = responseData.languages;
               this.certificates = responseData.certificates;
               this.bank_details = responseData.bank_details;
               this.offline_count = responseData.offline_count;
               this.online_count = responseData.online_count;               
                     
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },   

         updatePassword() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/doctors/Password";

            let formData = new FormData();
            formData.append("id", this.doctor.id); 
            formData.append("password", this.password); 
            formData.append("password_confirmation", this.password_confirmation); 
            
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('password-modal');
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         }, 
         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         },
         updatePin() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/change_pin";

            let formData = new FormData();
            formData.append("new_pin", this.new_pin); 
            formData.append("old_pin", this.old_pin); 
            formData.append("role_id", 2); 
            formData.append("id", this.doctor.id); 
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('pin-modal');
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                        this.$swal("", error.response.data.message, "error");

                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         }, 
         clearForm() {
            this.password = '';
            this.password_confirmation = '';
            this.new_pin = '';
            this.old_pin = '';
            this.errors = {};
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                        <router-link :to="{ name: 'doctors.schedules' }" class="btn btn-primary float-end me-2">Schedules</router-link>
                        <router-link :to="{ name: 'doctors.symptom.questions', params: {doctor_id: doctor.id} }" class="btn btn-primary float-end me-2">Symptoms Questions</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- Details starts -------->
                  <div class="row">
                     <div class=" col-lg-5 col-md-5">
                        <div class="card overflow-hidden">
                           <div class="bg-soft bg-primary">
                              <div class="row m-0">
                                 <div class="col-7">
                                 
                                 </div>
                                 <div class="col-5 align-self-end">
                                    <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
                                 </div>
                              </div>
                           </div>
                           <div class="card-body pt-2">
                              <div class="row">
                                 <div class="col-sm-4">
                                    <div class="avatar-md profile-user-wid mb-1">
                                       <img v-if="doctor.image" :src="$image_url + doctor.image" alt
                                       class="img-thumbnail rounded-circle">
                                       <img v-else src="@/assets/images/no-user.jpg"
                                       alt
                                       class="img-thumbnail rounded-circle"
                                       />
                                    </div>
                                    
                                 </div>
                                 <div class="col-sm-8 align-self-center">
                                    <h5 class="font-size-15">
                                       <span v-if="doctor.prefix == 1">Dr.</span><span v-else-if="doctor.prefix == 2">Mr.</span><span v-else-if="doctor.prefix == 3">Ms.</span> {{doctor.name}} {{doctor.qualification}}
                                    </h5>
                                    <p class="font-size-14 mt-3 mb-1">
                                       <i class="bx bx-phone me-1 text-primary"></i> 
                                       {{doctor.country_code}} {{doctor.mobile}}
                                    </p>
                                    <p class="font-size-14 mb-1">
                                       <i class="bx bx-envelope me-1 text-primary"></i>
                                       {{doctor.email}}
                                    </p>

                                    <p class="font-size-14 mb-1">
                                       <i class="bx bx-map me-1 text-primary"></i>
                                       {{doctor.address}}
                                    </p>
                                 </div>
                              </div>                              

                           </div>
                        </div>
                        <!-- end card -->     
                        <div class="d-grid gap-2">
                           <b-button v-b-modal.password-modal block variant="outline-primary">Change Password</b-button>
                           <b-button v-b-modal.pin-modal block variant="outline-primary">Change Pin Number</b-button>

                           <router-link :to="{ name: 'doctors.edit', params: {id: doctor.id} }" class="btn btn-outline-primary">Edit Profile</router-link>  
                        </div>

                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">                           
                           <div class="media">
                              <div class="avatar-sm align-self-center me-4 rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="bx bx-desktop font-size-24"></i>
                                 </span>
                              </div>
                              <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Online Consultations</p>
                                 <h4 class="mb-0">{{online_count}}</h4>
                              </div>

                              
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">                           
                           <div class="media">

                              <div class="avatar-sm align-self-center me-4 rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="fas fa-clinic-medical font-size-24"></i>
                                 </span>
                              </div>
                              <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Offline Consultations</p>
                                 <h4 class="mb-0">{{offline_count}}</h4>
                              </div>

                             
                           </div>
                        </b-card>
                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">  
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Settings</h4>
                           <div class="table-responsive w-100">
                              <table class="table mb-0">
                                 <tbody>
                                    <tr>
                                       <th width="70%">Ask questions regarding the patient's symptoms</th>
                                       <th width="5%">:</th>
                                       <td width="25%"><span v-if="doctor.ask_symptoms == 1">Yes</span><span v-else>No</span></td>
                                    </tr> 
                                    <tr>
                                       <th width="70%">Disable SMS service</th>
                                       <th width="5%">:</th>
                                       <td width="25%"><span v-if="doctor.disable_sms == 1">Yes</span><span v-else>No</span></td>
                                    </tr> 
                                    <tr>
                                       <th width="70%">Reserve tokens for token Vending Machine</th>
                                       <th width="5%">:</th>
                                       <td width="25%"><span v-if="doctor.reserve_token == 1">Yes</span><span v-else>No</span></td>
                                    </tr> 
                                    
                                    <tr>
                                       <th width="70%">Unlist from doctors listing</th>
                                       <th width="5%">:</th>
                                       <td width="25%"><span v-if="doctor.unlist == 1">Yes</span><span v-else>No</span></td>
                                    </tr> 
                                    <!-- <tr>
                                       <th width="70%">Unlist from clinics listing</th>
                                       <th width="5%">:</th>
                                       <td width="25%">No</td>
                                    </tr>  -->
                                    <tr>
                                       <th width="70%">Hide prescription from other doctors</th>
                                       <th width="5%">:</th>
                                       <td width="25%"><span v-if="doctor.hide_prescription == 1">Yes</span><span v-else>No</span></td>
                                    </tr> 
                                    <tr>
                                       <th width="70%">No. of days to show for booking</th>
                                       <th width="5%">:</th>
                                       <td width="25%">{{doctor.no_days_booking}}	</td>
                                    </tr> 
                                    <tr>
                                       <th width="70%">Doctor Type</th>
                                       <th width="5%">:</th>
                                       <td width="25%"><span v-if="doctor.doctor_type == 1">Premium</span><span v-else>Not Premium</span></td>
                                    </tr> 
                                    <tr>
                                       <th width="70%">Confirmation Screen (TVM)</th>
                                       <th width="5%">:</th>
                                       <td width="25%"><span v-if="doctor.confirm_screen == 1">Yes</span><span v-else>No</span></td>
                                    </tr>
                                    <tr v-if="doctor.confirm_screen == 1">
                                       <th width="70%">Confirmation Screen Time (seconds)</th>
                                       <th width="5%">:</th>
                                       <td width="25%">{{doctor.confirm_screen_time}}</td>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">  
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">ID Proof</h4>
                           <a :href="$image_url + doctor.id_proof" target="_blank"><img :src="$image_url + doctor.id_proof" alt="" style="max-width:100px"></a>
                           <!-- <ul class="list-inline p-0 m-0">                     
                              <li class="mb-3">
                                 
                                 <a href="#" class=""><p class="text-primary"><i class="fas fa-id-card me-3"></i></p></a>   

                              </li>
                              
                           </ul> -->
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">  
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Certificates</h4>
                           <ul class="list-inline p-0 m-0">                     
                              <li class="mb-3" v-for="(certificate) in certificates" :key="certificate.id">
                                 <a :href="$image_url + certificate.certificate" target="_blank" class="font-size-22"><p class="text-primary"><i class="fas fa-file-alt me-3"></i></p></a>  
                              </li>
                           </ul>
                        </b-card>

                     </div>

                     <div class="col-lg-7 col-md-7">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Doctor Details</h4>
                              

                              <div class="table-responsive ">
                                 <table class="table table-nowrap mb-0">
                                    <tbody>
                                       <tr>
                                          <th>Id</th>
                                          <th>:</th>
                                          <td>{{doctor.code}}</td>
                                       </tr> 
                                       
                                       <tr>
                                          <th width="45%">Gender</th>
                                          <th width="5%">:</th>
                                          <td width="50%">
                                             <span v-if="doctor.gender==1">Male</span>
                                             <span v-if="doctor.gender==2">Female</span>
                                             <span v-if="doctor.gender==3">Others</span>
                                          </td>
                                       </tr> 

                                       <tr>
                                          <th>D.O.B</th>
                                          <th>:</th>
                                          <td>{{doctor.dob | formatDate}}</td>
                                       </tr>  

                                         <tr>
                                          <th>Age</th>
                                          <th>:</th>
                                          <td>{{doctor.age}}</td>
                                       </tr>  


                                       <tr>
                                          <th>Current Hospital</th>
                                          <th>:</th>
                                          <td>{{doctor.current_hospital}}</td>
                                       </tr>

                                       <tr>
                                          <th>Specializations</th>
                                          <th>:</th>
                                          <td>
                                             <span v-for="(specialization) in specializations" :key="specialization.id">{{specialization.specialization}}<br></span>
                                          </td>
                                       </tr>     

                                       <tr>
                                          <th>Languages</th>
                                          <th>:</th>
                                          <td>
                                             <span v-for="(language) in languages" :key="language.id">{{language.language}}<br></span>
                                          </td>
                                       </tr>
                                       <tr>
                                          <th>Convenience Fee</th>
                                          <th>:</th>
                                          <td>{{doctor.convenience_fee}}</td>
                                       </tr> 
                                       <tr>
                                          <th>Platform Fee</th>
                                          <th>:</th>
                                          <td>{{doctor.commision}}</td>
                                       </tr> 
                                       <tr>
                                          <th>Created on</th>
                                          <th>:</th>
                                          <td>{{doctor.converted_created_at}}</td>
                                       </tr>   
                                       <tr>
                                          <th>Created by</th>
                                          <th>:</th>
                                          <td>{{doctor.added_user_name}}</td>
                                       </tr>  
                                    </tbody>
                                 </table>
                              </div>
                           
                        </b-card>
                        <!-- end card -->

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Registration Details</h4>                            
                              <div class="table-responsive ">
                                 <table class="table table-nowrap mb-0">
                                    <tbody>                                       
                                       <tr>
                                          <th width="45%">Reg. No</th>
                                          <th width="5%">:</th>
                                          <td>{{doctor.reg_no}}</td>
                                       </tr>               
                                       
                                       <tr>
                                          <th>Reg. Council</th>
                                          <th>:</th>
                                          <td>{{doctor.reg_council}}</td>
                                       </tr>

                                       <tr>
                                          <th>Reg. Date:</th>
                                          <th>:</th>
                                          <td>{{doctor.reg_date | formatDate}}</td>
                                       </tr>     
                                    </tbody>
                                 </table>
                              </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light" v-if="bank_details.length">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Bank Details</h4>
                              <div class="table-responsive ">
                                 <table class="table table-nowrap mb-0">
                                    <tbody> 

                                       <tr>
                                          <th width="45%">Account No</th>
                                          <th width="5%">:</th>
                                          <td>{{bank_details[0].account_no}}</td>
                                       </tr>

                                       <tr>
                                          <th>Account Holder Name</th>
                                          <th>:</th>
                                          <td>{{bank_details[0].account_holder_name}}</td>
                                       </tr>          
                                       
                                       <tr>
                                          <th>IFSC Code</th>
                                          <th>:</th>
                                          <td>{{bank_details[0].ifsc_code}}</td>
                                       </tr>

                                       <tr>
                                          <th>UPI ID</th>
                                          <th>:</th>
                                          <td>{{bank_details[0].upi_id}}</td>
                                       </tr>   
                                    </tbody>
                                 </table>
                              </div>
                        </b-card>

                     </div>
                     
                  </div>
                  <!---- Details ends -------->

               </div>
            </div>
         </div>
      </div>

      <!---- modal starts ---->
      <b-modal ref="password-modal" id="password-modal" title="Change Password" hide-footer @hidden="clearForm()">
         <b-form @submit.prevent="updatePassword()">
            <b-row>  
               <b-col lg="12" class="form-group">
                  <label class="control-label">New Password<span class="text-danger">*</span></label>
                  <b-form-input type="password" v-model="password"  v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>

                  <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
               </b-col>  

               <b-col lg="12" class="form-group">
                  <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                  <b-form-input type="password" v-model="password_confirmation"  v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>

                  <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
               </b-col>    
               
               <b-col lg="12">
                  <b-button type="submit" class="me-3" variant="primary">Update</b-button>
                  <b-button class="" variant="light" @click="hideModal('password-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->

       <!---- modal starts ---->
       <b-modal ref="pin-modal" id="pin-modal" title="Change Pin Number" hide-footer @hidden="clearForm()">
         <b-form @submit.prevent="updatePin()">
            <b-row>  
               <b-col lg="12" class="form-group">
                  <label class="control-label">Old Pin Number<span class="text-danger">*</span></label>
                  <b-form-input v-model="old_pin" @keypress="numbersOnly" autocomplete="off" maxlength="4" v-bind:class="{ 'is-invalid': Boolean(errors.old_pin) }"></b-form-input>

                  <div v-for="(val, index) in errors.old_pin" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
               </b-col>  

               <b-col lg="12" class="form-group">
                  <label class="control-label">New Pin Number<span class="text-danger">*</span></label>
                  <b-form-input v-model="new_pin" @keypress="numbersOnly" autocomplete="off" maxlength="4" v-bind:class="{ 'is-invalid': Boolean(errors.new_pin) }"></b-form-input>

                  <div v-for="(val, index) in errors.new_pin" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
               </b-col>    
               
               <b-col lg="12">
                  <b-button type="submit" class="me-3" variant="primary">Update</b-button>
                  <b-button class="" variant="light" @click="hideModal('pin-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->
   </Layout>
</template>
